import { TutorialContentMap } from "@/lib/types/tutorial";

export const TUTORIAL_CONTENT: TutorialContentMap = {
  add_bulk_pictures: {
    id: 'add_bulk_pictures',
    feature: 'buy_for_me',
    title: 'Add Multiple Pictures All at Once',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/buy-for-me/web/Add%20Multiple%20Pictures%20L3.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/buy-for-me/mobile/Multiple%20Pictures.mp4',
    steps: [
      'Click on “Add Bulk Pictures”',
      'Select all the pictures you want from your gallery',
      'Click on “Save to Cart”',
      'Fill in the Quantities and Specifications such as colors, size, weight, e.t.c.  '
    ],
  },
  
  add_bulk_links: {
    id: 'add_bulk_links',
    feature: 'buy_for_me',
    title: 'Add Multiple Links All at Once',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/buy-for-me/web/Adding%20multiple%20links.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/buy-for-me/mobile/Multiple%20Links%20to%20Cart.mp4',
    steps: [
      'Click on “Add Bulk Links”',
      'Copy & paste a list of online store links that you have saved somewhere e.g Whatsapp, Notes, Telegram, e.t.c. Make sure to begin each link on a new line ',
      'Click on “Save to Cart”',
      'Fill in the Quantities and Specifications such as colors, size, weight, e.t.c.  '
    ],
  },
  
  add_link_item: {
    id: 'add_link_item',
    feature: 'buy_for_me',
    title: 'Add Product Link to Cart',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/buy-for-me/web/Adding%20Links%20to%20Cart%20L3.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/buy-for-me/mobile/Link%20to%20Cart.mp4',
    steps: [
      'Click on “Add Link Item”',
      'Copy & paste a product link that you have from 1688, Alibaba, Pinduoduo, Aliexpress e.t.c.',
      'Fill in the Quantity and Specifications such as colors, size, weight, e.t.c.  ',
      'Click on “Save to Cart”'
    ],
  },
  
   add_picture_item: {
    id: 'add_picture_item',
    feature: 'buy_for_me',
    title: 'Add Product Picture to Cart',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/buy-for-me/web/Adding%20Pictures%20to%20Cart.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/buy-for-me/mobile/Picture%20to%20Cart.mp4',
    steps: [
      'Click on “Add Picture Item”',
      'Upload a Picture of the Item from your gallery',
      'Fill in the Quantity and Specifications such as colors, size, weight, e.t.c.  ',
      'Click on “Save to Cart”'
    ],
  },

  add_text_item: {
    id: 'add_text_item',
    feature: 'buy_for_me',
    title: 'Describe the Product you Want',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/buy-for-me/web/Adding%20Text%20Items%20to%20Cart.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/buy-for-me/mobile/Text%20Item%20to%20Cart.mp4',
    steps: [
      'Describe the product in detail, using more than 50 characters',
      'Add Specifications such as colors, size, weight, e.t.c.',
      'Add Quantity',
      'Click on “Save to Cart”'
    ],
  },

  create_order: {
    id: 'create_order',
    feature: 'buy_for_me',
    title: 'Create Your First Order',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/buy-for-me/web/Create%20an%20order.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/buy-for-me/mobile/Create%20An%20Order.mp4',
    steps: [
      'Select ALL the Items you want to buy  from your Cart (Make sure you fill the quantity and specification)',
      'Click “Create Order”',
      'Add Order Title and choose whether you want to ship by air or sea (You will have the option to change this later)',
      'Click “Request Quote”'
    ],
  },

  // Ship Feature 
 request_shipment: {
    id: 'request_shipment',
    feature: 'ship',
    title: 'Request Shipment',
    webVideo: 'https://pub-xxxxx.r2.dev/buy-for-me-start.mp4',
    mobileVideo: 'https://pub-xxxxx.r2.dev/buy-for-me-start.mp4',
    steps: [
      'Choose the warehouse that your good are stored in',
      'Select the parcels/orders that you want to ship and click “Request Shipment”',
      'Choose how you want your goods shipped',
      'Your shipment request will be processed within 24 hours'
    ],
  },
  
  track_shipment: {
    id: 'track_shipment',
    feature: 'ship',
    title: 'Ship Items',
    webVideo: 'https://pub-xxxxx.r2.dev/buy-for-me-start.mp4',
    mobileVideo: 'https://pub-xxxxx.r2.dev/buy-for-me-start.mp4',
    steps: [
      'Select a shipment in-transit that you want to track',
      'Click “Track Shipment”',
      'Know where your shipment is everytime!'
    ],
  },
  
  ship_local: {
    id: 'ship_local',
    feature: 'ship',
    title: 'Local Delivery',
    webVideo: 'https://pub-xxxxx.r2.dev/buy-for-me-start.mp4',
    mobileVideo: 'https://pub-xxxxx.r2.dev/buy-for-me-start.mp4',
    steps: [
      'Choose whether you want it delivered to your doorstep or a park in your city',
      'Fill in the correct delivery information and you will see an estimated cost',
      'Your request will be processed in 24 hours and the actual cost will be displayed',
      'Make Payment and your shipment will be on its way to you.'
    ],
  },

  // Store Feature 
  add_multiple_parcels: {
    id: 'add_multiple_parcels',
    feature: 'store',
    title: 'Add Multiple Parcels',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/store/web/Multiple%20Parcels%20.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/store/mobile/Multiple%20Parcels.mp4',
    steps: [
      'Get all of your parcels codes together from 1688, Alibabe, Pinduoduo, e.t.c. (Or ask your supplier)',
      'Make sure each parcel code is on a new line and add them all at once',
      'Select how you want your goods shipped, AIR or SEA.  (You will have the option to change this later)',
      'If you want quality check, indicate, and fill in the details of the goods. '
    ],
  },
  
  add_single_parcel: {
    id: 'add_single_parcel',
    feature: 'store',
    title: 'Add Single Parcel',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/store/web/Single%20Parcels.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/store/mobile/Single%20parcel.mp4',
    steps: [
      'Get the tracking number of your goods from 1688, Alibaba, Pinduoduo   e.t.c. (Or ask your supplier)',
      'Select how you want your goods shipped, AIR or SEA.  (You will have the option to change this later)',
      'If you want quality check, indicate, and fill in the details of the goods. '
    ],
  },
  
  warehouse_address: {
    id: 'warehouse_address',
    feature: 'store',
    title: 'Warehouse Address',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/store/web/Warehouse%20Web%20Layer%203.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/store/mobile/Warehouse%20Address%20Layer%203.mp4',
    steps: [
      'Share your warehouse address to your supplier exactly as it is . No translation, no changes.',
      'Too add your warehouse address to 1688, Alibaba, Pinduoduo, e.t.c. , check the help section for a detailed guide.  '
    ],
  },

  // Wallet Feature 
  fund_wallet: {
    id: 'fund_wallet',
    feature: 'wallet',
    title: 'Fund Wallet',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/wallet/web/Fund%20wallet%20.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/wallet/mobile/Fund%20Wallet%202.mp4',
    steps: [
      'Enter amount you want to fund in your local currency',
      'Follow the instruction on your screen',
      'Receive CNY (RMB) in your wallet in minutes '
    ],
  },
  
  send_money: {
    id: 'send_money',
    feature: 'wallet',
    title: 'Send Money',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/wallet/web/Send%20Money.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/wallet/mobile/Send%20Money%202.mp4',
    steps: [
      'Ensure your wallet has funds in it ',
      'Enter the amount you want to send in CNY (RMB)',
      'Choose whether you are sending to a bank or Alipay',
      'Input the full legal name of your recipient '
    ],
  },
  
  withdraw: {
    id: 'withdraw',
    feature: 'wallet',
    title: 'Withdraw Funds',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/wallet/web/Withdraw.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/wallet/mobile/Withdraw%202.mp4',
    steps: [
      'Enter amount you want to withdraw in CNY (RMB)',
      'Fill in correct bank details as prompted',
      'Click withdraw',
      'Receive your local currency in your bank within 48 hours '
    ],
  },
  
  upgrade_kyc: {
    id: 'upgrade_kyc',
    feature: 'kyc',
    title: 'Upgrade KYC',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/kyc/KYC%20Web%20Layer%203.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/kyc/KYC%20Mobile%20Layer%203.mp4',
    steps: [
      'Select tier to be upgraded to',
      'Provide all verification information required ',
      'Proceed to confirm',
      'The verification may take up to 24 hours'
    ],
  },

  welcome_video: {
    id: 'welcome_video',
    feature: 'layer1',
    title: 'A Special Message for You',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/Layer%201%20video.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/Layer%201%20video.mp4',
    steps: [], 
  },

  buy_for_me: {
    id: 'buy-for_me',
    feature: 'layer2',
    title: 'Intro to Buy-For-Me',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/Layer%202/web/Buy%20for%20me%20layer%202%20(1).mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/Layer%202/mobile/buy%20for%20me%20layer%202.mp4',
    steps: [],
  },
  store: {
    id: 'store',
    feature: 'layer2',
    title: 'Intro to Store feature',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/Layer%202/web/Layer%202%20Store.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/Layer%202/mobile/Store%20layer%202%20video.mp4',
    steps: [],
  },
  wallet: {
    id: 'wallet',
    feature: 'layer2',
    title: 'Intro to Wallet feature',
    webVideo: 'https://pubres.proc360.app/onboardingVideos/Layer%202/web/Layer%202%20Wallet.mp4',
    mobileVideo: 'https://pubres.proc360.app/onboardingVideos/Layer%202/mobile/wallet%20layer%202%20video.mp4',
    steps: [],
  }
};